import Image from '@/components/Image';
import priceDrop from './assets/price-drop.svg';
import priceDropPc from './assets/price-drop-pc.svg';
import priceDropDetailMobile from './assets/price-drop-detail-mobile.svg';

export default function YearLowestPriceLabel({
  text,
  size = 'mobile',
}: {
  text?: string;
  size?: 'mobile' | 'desktop' | 'detail-mobile';
}) {
  const label = typeof text === 'string' ? text.trim() : '';
  if (!label) return null;

  return (
    <span
      data-year-lowest-price
      className={`inline-flex max-w-full min-w-0 items-center gap-4 font-bs text-promotion-red ${size === 'desktop' ? 'min-h-[20px] text-14' : size === 'detail-mobile' ? 'min-h-[18px] text-12' : 'text-12'}`}
    >
      <Image
        src={
          size === 'desktop'
            ? priceDropPc
            : size === 'detail-mobile'
              ? priceDropDetailMobile
              : priceDrop
        }
        alt=""
        width={size === 'desktop' ? 14 : 12}
        height={size === 'desktop' ? 16 : 13}
        className="shrink-0"
      />
      <span className="min-w-0 break-words">{label}</span>
    </span>
  );
}
